module.exports = __webpack_public_path__ + "fonts/Open_Sans-300-latin-ext10.57b3072.woff2";